<template>
  <div>
    <div id="captchaElement"></div>
  </div>
</template>
<script>
const SCENE_ID = window.ALI_CAPTCHA_SCENE_ID;
export default {
  props: {
    initPlugin: {
      type: String,
      value: null
    },
    triggerElement: {
      type: String,
      value: ""
    },
    captchaReset: {
      type: String,
      value: null
    }
  },
  data() {
    return {
      captcha: null
    }
  },
  watch: {
    initPlugin: {
      handler(val) {
        if(val) this.initCaptcha()
      },
      immediate: true
    },
    captchaReset(val) {
      if (val) {
        this.resetCaptcha()
      }
    }
  },
  methods: {
    // 验证码初始化
    initCaptcha () {
      if (!window.initAliyunCaptcha) return
      window.initAliyunCaptcha({
        SceneId: SCENE_ID,
        // 验证码模式，popup表示弹出式，embed表示嵌入式。无需修改
        mode: "popup",
        // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
        element: "#captchaElement",
        // 触发验证码弹窗或无痕验证的元素
        button: this.triggerElement,
        // 滑块验证和一点即过的验证形态触发框体样式，支持自定义宽度和高度，单位为px。兼容历史参数名。
        slideStyle: {
          width: 360,
          height: 40,
        },
        // 验证码验证通过回调函数
        success: this.onSuccess,
        // 验证码验证不通过回调函数
        fail: this.onFail,
        // 绑定验证码实例回调函数，该回调会在验证码初始化成功后调用
        getInstance: (instance) => {
          this.captcha = instance;
        }
      });
    },
    onSuccess (captchaRes) {
      if (this.captcha && typeof this.captcha.refresh === 'function') {
        this.captcha.refresh()
      }
      this.$emit('captchaSuccess', captchaRes)
    },
    onFail () {
      this.$emit('captchaFail', true)
    },
    resetCaptcha() {
      if (this.captcha && typeof this.captcha.refresh === 'function') {
        this.captcha.refresh()
      }
      this.$emit('captchaReset', true)
    }
  }
}
</script>

<style scoped lang="less">

</style>
